/**
 * @file: 事件封装
 * @author: xiaolong.huang@dmall.com
 */

import UUID from './uuid';

const FILTERTYPE = ['on', 'fire'];

class Event {
    callbacks: any = {};
    filters: any = {};

    on(eventName, callback, context?, callbackId?) {
        var self = this,
            callbacks = this.callbacks,
            eventNameList, callbackObj, i, name;

        eventNameList = typeof eventName == 'string' ? [eventName] : eventName;
        for (i = 0; name = eventNameList[i]; ++i) {
            callbacks[name] = callbacks[name] || [];
            callbackObj = {
                callback: callback,
                context: context,
                callbackId: callbackId || new UUID().id
            }
            if (checkFilter(self, 'on', name, callbackObj) === false) return;
            callbacks[name].push(callbackObj);
        }
    }

    fire(eventName, params?) {
        var callbacks = this.callbacks,
            args = [].splice.apply(arguments, [1]),
            self = this,
            i, callbackObj;

        if (!callbacks[eventName]) return;
        for (i = 0; callbackObj = callbacks[eventName][i]; ++i) {
            if (checkFilter.apply(null, [self, 'fire', eventName].concat(callbackObj).concat(args)) === false) continue;
            if (typeof callbackObj.callback === 'function'
                && callbackObj.callback.apply(callbackObj, args) === false) {
                return false;
            }
        }
    }

    clearAll() {
        this.callbacks = {};
    }

    addFilter(type, filter) {
        var self = this,
            filterList;

        if (FILTERTYPE.indexOf(type) === -1) return;

        filterList = self.filters[type] = self.filters[type] || []
        filterList.push(filter);
    }

    unbind(eventName, functionId) {
        var self = this,
            callbacks = self.callbacks,
            eventNameList, i, name, k;

        eventNameList = typeof eventName == 'string' ? [eventName] : eventName;
        for (i = 0; name = eventNameList[i]; ++i) {
            var eventCallbacks = callbacks[name] || [];

            for (k = 0; k < eventCallbacks.length; k++) {
                var callback = eventCallbacks[k];
                if (callback.callbackId == functionId) {
                    eventCallbacks.splice(k, 1);
                    k--;
                }
            }
        }
    }
}

function checkFilter(caller, type, callbackObj, data) {
    var filterList = caller.filters[type],
        args = [].splice.apply(arguments, [3]),
        i, f;

    if (!filterList || !filterList.length) {
        return;
    }
    for (i = 0; f = filterList[i]; ++i) {
        return f.apply(callbackObj, [callbackObj].concat(args));
    }
}

export default Event;
